import ConvenioDelete from './ConvenioDelete'
export {ConvenioDelete}
export default ConvenioDelete
